import {Routes} from "@angular/router";
import {MyDetailsComponent} from "./my-details/my-details.component";

export const detailsRoutes: Routes = [
  {path: '', component: MyDetailsComponent}
];
